<template>
<panel>
  <p slot="header">
    {{ item.first_name }} {{ item.last_name }}
  </p>
  <p slot="actions">
    <ui-button type="flat" color="primary" @click="cancel">Anuluj</ui-button>
  </p>
  <users-form :item="item" v-if="item.id"></users-form>
</panel>
</template>

<script>
import Users from './../../services/Users'
import Loading from './../../mixins/Loading'
import Notify from './../../mixins/Notify'

export default {
  mixins: [Loading, Notify],
  data () {
    return {
      item: Users.getBaseItem()
    }
  },
  mounted () {
    const id = this.$route.params.id
    this.getItem(id)
  },
  methods: {
    cancel () {
      this.$router.push({name: 'admin.users.dashboard', params: {id: this.item.id}})
    },
    getItem (id) {
      this.setLoading(true)
      Users.get(id).then((res) => {
        this.item = res.data.item
        this.setLoading(false)
      })
    }
  }
}

</script>


// WEBPACK FOOTER //
// Edit.vue?691d0821